// https://github.com/tc39/proposal-global
var $export = require('./_export');

$export($export.G, { global: require('./_global') });



//////////////////
// WEBPACK FOOTER
// ./~/public-sdk/~/core-js/modules/es7.global.js
// module id = 291
// module chunks = 0